<div class="persistent-error d-flex">
  <div class="pe-2">
    <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
  </div>
  <div>
    <div class="persistent-error-title">{{ title | translate }}</div>
    <div class="persistent-error-body">
      {{ body | translate: { reason: reason ? (reason | translate) : "" } }}
    </div>
  </div>
</div>
